// extracted by mini-css-extract-plugin
export default {"provider":"WalletProviderModal_provider__oFiIG","divider":"WalletProviderModal_divider__T27Zb"};